import Money from '@components/application/money';
import { Vehicle } from '@sharedTypes/Vehicle';

type VehiclePreviewProps = Pick<
  Vehicle,
  'cashPrice' | 'cashPriceSuffix' | 'make' | 'model' | 'photo' | 'variant'
>;

const VehiclePreview = ({
  photo,
  make,
  model,
  variant,
  cashPrice,
  cashPriceSuffix,
}: VehiclePreviewProps): JSX.Element => {
  return (
    <div className="db-vehicle__wrapper">
      {photo && <img alt="" className="ch-img--responsive" src={photo} />}

      <div className="db-vehicle__content">
        <span className="db-vehicle__title">
          {make} {model}
          <span className="db-vehicle__variant ch-text--ellipsis">
            {variant}
          </span>
        </span>
        <span className="db-vehicle__price">
          <Money amount={cashPrice} />
          {cashPriceSuffix && (
            <span className="ch-fs--3"> {cashPriceSuffix}</span>
          )}
        </span>
      </div>
    </div>
  );
};

export default VehiclePreview;
